import { OrangeButton } from '@/components/Buttons';
import { GenericForm, GenericFormBGContainer } from '@/components/GenericForm';
import { Divider } from '@/components/misc';
import { EMPLOYEE_ROLES, EmployeeProps } from '@/interfaces/employee_type';
import { UseFormRegister, Control, FieldErrors } from 'react-hook-form';
import { EmployeeFormData } from './EmployeeForm';
import { Input } from '@/components/_Shared/Form/Inputs/Input';
import { SelectContainer } from '@/components/_Shared/Form/Inputs/Select';
import { Submit } from '@/components/_Shared/Form/Buttons/Submit';

export type EmployeeFormBaseProps = {  
    employee: EmployeeProps
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
    method: "POST" | "PUT"
    isProcessing: boolean
    isChangePassword: boolean
    canChangeRole: boolean
    register: UseFormRegister<EmployeeFormData>
    control: Control<EmployeeFormData>
    errors: FieldErrors<EmployeeFormData>
}

export function EmployeeFormBase(props: EmployeeFormBaseProps) {
    const { employee, onSubmit, method, isProcessing, isChangePassword, canChangeRole, register, control, errors } = props
    const PasswordTooltip = method === "POST" ? "Password" : "Current Password";

    return (
        <GenericForm form_id="employee_creation" onSubmit={onSubmit}>
            <GenericFormBGContainer>
                <h2 className="text-2xl font-bold">{method === "POST" ? "Create" : "Update"} Employee {isChangePassword ? "Password" : ""}</h2>

                <Divider />

                <Input label="Name" name="name" type="text" register={register} defaultValue={employee.name}/>
                {errors.name && <p className="text-red-500 dark:text-red-400">{errors.name.message}</p>}

                <Input label="Email" name="email" type="email" register={register} defaultValue={employee.email}/>
                {errors.email && <p className="text-red-500 dark:text-red-400">{errors.email.message}</p>}

                <Input label={PasswordTooltip} name="password" type="password" register={register} defaultValue={employee.password}/>
                {errors.password && <p className="text-red-500 dark:text-red-400">{errors.password.message}</p>}

                <Input label={"Re-enter " + PasswordTooltip} name="re_password" type="password" register={register} defaultValue={employee.password}/>
                {errors.re_password && <p className="text-red-500 dark:text-red-400">{errors.re_password.message}</p>}

                {canChangeRole && 
                    <>
                        <SelectContainer name="role" options={EMPLOYEE_ROLES} placeholder="Select a role" control={control} required/>
                        {errors.role && <p className="text-red-500 dark:text-red-400">{errors.role.message}</p>}
                    </>
                }

                {isProcessing ? 
                    <OrangeButton>Processing...</OrangeButton>
                : 
                    <Submit label={method === "POST" ? "Create Employee" : "Update Employee"} isSubmitting={isProcessing}/>
                }
            </GenericFormBGContainer>
        </GenericForm>
    )
}
